import React from 'react'

const Nav = () => {
  return (
    <div className="bg-bgDark py-4">
        <h1 className="text-3xl font-bold text-center text-white">Top Courses</h1>
    </div>
  )
}

export default Nav